import { render, staticRenderFns } from "./checkup-results-radarchart.vue?vue&type=template&id=35bd2530&scoped=true&"
import script from "./checkup-results-radarchart.vue?vue&type=script&lang=js&"
export * from "./checkup-results-radarchart.vue?vue&type=script&lang=js&"
import style0 from "./checkup-results-radarchart.vue?vue&type=style&index=0&id=35bd2530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd2530",
  null
  
)

export default component.exports